export const ApiDef_FindingView = {
    _v1: {}
};
//# sourceMappingURL=api-def.js.map